require("@babel/polyfill");
window._ = require( 'lodash' );
import Popper from 'popper.js/dist/umd/popper.js';
import Sortable, {AutoScroll} from "sortablejs/modular/sortable.core.esm";
Sortable.mount(new AutoScroll());
window.Sortable = Sortable;
window.YTPlayer = require('yt-player');
window.$ = window.jQuery = require( 'jquery' );
window.Tether = require( 'tether' );
window.Popper = Popper;
require( 'bootstrap' );
require('dropzone');
require( 'bootstrap4-datetimepicker' );

// lightbox
window.lightbox = require( 'lightbox2' );

// nestable
window.nestable = require('nestable2');

// feathericon.com
window.feather = require('feather-icons');

//tinymce
window.tinymce = require( 'tinymce' );

// clipboard
window.ClipboardJs = require ('clipboard');

// owl slider
require('owl.carousel');

// html5 player
window.Plyr = require('plyr');

// Momentjs
window.Moment = require( 'moment-timezone' );
Moment.tz.setDefault( 'America/Chicago' );

window.axios = require( 'axios' );
window.axios.defaults.headers.common[ 'X-Requested-With' ] = 'XMLHttpRequest';

let token = document.head.querySelector( 'meta[name="csrf-token"]' );
window.csrfToken = document.head.querySelector( 'meta[name="csrf-token"]' );

if ( token ) {
	window.axios.defaults.headers.common[ 'X-CSRF-TOKEN' ] = token.content;
}
else {
	console.error( 'CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token' );
}
